export function synchronizedPlaybackDelayMs(startsAt, now = Date.now(), serverClockOffsetMs = 0) {
  const target = Number(startsAt);
  const current = Number(now);
  const offset = Number(serverClockOffsetMs);
  if (!Number.isFinite(target) || !Number.isFinite(current)) return 0;
  return Math.max(0, target - (current + (Number.isFinite(offset) ? offset : 0)));
}

export function synchronizedStartTimestamp(primary, fallback) {
  for (const value of [primary, fallback]) {
    if (value == null || value === '') continue;
    const timestamp = Number(value);
    if (Number.isFinite(timestamp)) return timestamp;
  }
  return undefined;
}

export function synchronizedAudioContextStartTime(contextTime, startsAt, now = Date.now(), serverClockOffsetMs = 0) {
  const safeContextTime = Number.isFinite(Number(contextTime)) ? Number(contextTime) : 0;
  return safeContextTime + synchronizedPlaybackDelayMs(startsAt, now, serverClockOffsetMs) / 1000;
}
